import { render, staticRenderFns } from "./static.vue?vue&type=template&id=097e14d6&scoped=true&"
import script from "./static.vue?vue&type=script&lang=js&"
export * from "./static.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097e14d6",
  null
  
)

export default component.exports